class ConfigManager {
  constructor() {
    this._config = null
  }

  // 加载配置
  async loadConfig() {
    try {
      // 根据环境选择配置路径
      const configPath = process.env.NODE_ENV === 'development'
        ? '/config/config.json'
        : './config/config.json'

      const response = await fetch(configPath)
      this._config = await response.json()
      // console.log('配置加载成功:', this._config)
    } catch (error) {
      console.error('配置加载失败:', error)
      // 使用默认配置作为后备
      this._config = {
        siteName: "姜堰教育",
        statStart: "2020.06.15",
        baseUrl: "https://www.jycfd.cn",
        moniterSrv: ":18888",
        albumUrl: "/html/album"
      }
    }
  }

  // 获取配置项
  get(key) {
    if (!this._config) {
      console.warn('配置尚未加载')
      return null
    }
    return this._config[key]
  }

  // 获取完整URL
  getFullUrl(path) {
    const baseUrl = this.get('baseUrl') || ''
    return baseUrl + path
  }

  // 获取所有配置
  getAll() {
    return this._config
  }
}

// 创建单例
const configManager = new ConfigManager()
export default configManager